import React from 'react'
import { Box, Typography, Container, Paper, Button, Stack } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', bgcolor: 'background.paper' }}>
          <Typography variant="h1" sx={{ fontWeight: 700, fontSize: '4rem', color: 'error.main', mb: 1 }}>404</Typography>
          <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Página No Encontrada</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            La página que está buscando no existe o ha sido movida.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="contained" onClick={() => navigate('/')}>Ir a Inicio</Button>
            <Button variant="outlined" onClick={() => navigate(-1)}>Volver</Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}
